import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../selectors/components/header/notifications';
import {toggleNotifications, loadNotifications} from '../../../../../reducers/notifications/actions';
import Notification from './notification';
import FreeplayBonus from './freeplay_bonus';
import RandomBoost from './random_boost';

export default () => {
    const {loaded, opened, has_unread, notifications} = useSelector(Selector),
          dispatch = useDispatch();

    const toggle = () => {
        const element = document.querySelector('.notifications-container');

        if(!element)
            return dispatch(toggleNotifications());

        element.classList.remove('animate__fadeIn');
        element.classList.add('animate__fadeOut');

        window.notificationCloseAction = true;

        setTimeout(() => {
            window.notificationCloseAction = false;
            dispatch(toggleNotifications(opened));
        }, 500);
    }

    const outClickHandler = e => {
        const block = document.querySelector('.notifications-block');

        if(!block.contains(e.target))
            if(opened && !window.notificationCloseAction)
                toggle();
    }

    useEffect(() => {
        document.addEventListener('click', outClickHandler);
        return () => document.removeEventListener('click', outClickHandler);
    }, [opened]);

    useEffect(() => {
        if(!loaded)
            dispatch(loadNotifications());
    }, [loaded]);
    
    return (
        <div className="notifications-block">
            <div className="button" onClick={e => {
                if(loaded)
                    toggle();
            }}>
                {has_unread ? <div className="dot animate__animated animate__heartBeat animate__infinite"></div> : <></>}
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.0167 2.42505C7.25841 2.42505 5.01674 4.66672 5.01674 7.42505V9.83338C5.01674 10.3417 4.80007 11.1167 4.54174 11.55L3.58341 13.1417C2.99174 14.125 3.40007 15.2167 4.48341 15.5834C8.07507 16.7834 11.9501 16.7834 15.5417 15.5834C16.5501 15.25 16.9917 14.0584 16.4417 13.1417L15.4834 11.55C15.2334 11.1167 15.0167 10.3417 15.0167 9.83338L15.0167 7.42505C15.0167 4.67505 12.7667 2.42505 10.0167 2.42505Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
                    <path d="M11.5584 2.6667C11.3001 2.5917 11.0334 2.53337 10.7584 2.50003C9.95843 2.40003 9.19176 2.45837 8.4751 2.6667C8.71676 2.05003 9.31676 1.6167 10.0168 1.6167C10.7168 1.6167 11.3168 2.05003 11.5584 2.6667Z" fill="none" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.5166 15.8833C12.5166 17.2583 11.3916 18.3833 10.0166 18.3833C9.33327 18.3833 8.69993 18.1 8.24993 17.65C7.79993 17.2 7.5166 16.5666 7.5166 15.8833" fill="none" stroke-width="1.5" stroke-miterlimit="10"/>
                </svg>
            </div>

            {(opened && loaded) ? (
                <div className="notifications-container animate__animated animate__fadeIn animate__faster">
                    <div className="notifications-title">Notifications</div>
                    <div className="notifications-list">

                        {/* <div className="notification-bonus boost"> 
                            <div className="border"></div>
                            <div className="bonus-content">
                                <div className="bonus-info">
                                    <div className="left">
                                        <div className="image"></div>
                                    </div>

                                    <div className="right">
                                        <div className="title">Your Free Game Awaits</div>
                                        <div className="text">You’ve got a free play available — claim it before it’s gone.</div>
                                    </div>
                                </div>

                                <div className="bonus-button">Claim FreePlay</div>
                            </div>
                        </div> */}

                        {notifications.length < 1 ? (
                            <div className="empty">No notifications yet</div>
                        ) : (
                            <>
                                {notifications.map((notification, key) => {
                                    if(notification.details.type === "bonus") {
                                        if(notification.details.bonus_type === "freeplay")
                                            return <FreeplayBonus {...notification} key={key} toggleFunc={toggle} />
                                    
                                        if(notification.details.bonus_type === "boost")
                                            if(notification.details.bonus_offer.type === "random")
                                                return <RandomBoost {...notification} key={key} toggleFunc={toggle} /> 
                                    }

                                    if(notification.details.type === 'notification')
                                        return <Notification {...notification} key={key} toggleFunc={toggle} />
                                })}
                            </>
                        )}

                    </div>
                </div>
            ) : (
                <></>
            )}
        </div>
    )
}